<section class="content-card">
  <div class="content-title">Master Data</div>
  <app-master-data-editor></app-master-data-editor>

  <kendo-grid [kendoGridBinding]="items" [filterable]="true">
    <kendo-grid-column [width]="150" field="name" title="Name"></kendo-grid-column>
    <kendo-grid-column [width]="150" field="displayText" title="Display Text"></kendo-grid-column>
    <kendo-grid-column [width]="150" field="masterDataTypeStr" title="Master Data Type"></kendo-grid-column>

    <ng-template kendoGridLoadingTemplate>
      <div class="k-loading-color"></div>
      <div class="loading-container">
        <kendo-loader type="converging-spinner" size="large"></kendo-loader>
      </div>
    </ng-template>
  </kendo-grid>
</section>
